import { getContract } from "./utils.js";

import ABI_ERC21_GenArt from "../constants/abis/GenArt.json";

import ABI_ERC21_EyesFiClub from "../constants/abis/EyesFiClub.json";

import ABI_ERC21_EyesFiMint from "../constants/abis/EyesFiMint.json";

import ABI_ERC21_MyNFT from "../constants/abis/MyNFT.json";

import ABI_ERC21_exchange from "../constants/abis/exchange.json";

import ABI_ERC20_weth from "../constants/abis/weth.json";

import ABI_testcon from "../constants/abis/testcon.json";


// returns null on errors
function useContract(
  library,
  account,
  address,
  ABI,
  withSignerIfPossible = true
) {
  if (!address || !ABI || !library) return null;
  try {
    // return new web3.eth.Contract(ABI,address)
    return getContract(
      address,
      ABI,
      library,
      withSignerIfPossible && account ? account : undefined
    );
  } catch (error) {
    console.error("Failed to get contract", error);
    return null;
  }
}


export function useABI_ERC21_GenArtContract(
  library,
  account,
  tokenAddress,
  withSignerIfPossible
) {

  return useContract(
    library,
    account,
    tokenAddress,
    ABI_ERC21_GenArt,
    withSignerIfPossible
  );
}


export function useABI_ERC21_EyesFiClubContract(
  library,
  account,
  tokenAddress,
  withSignerIfPossible
) {

  return useContract(
    library,
    account,
    tokenAddress,
    ABI_ERC21_EyesFiClub,
    withSignerIfPossible
  );
}


export function useABI_ERC21_EyesFiMintContract(
  library,
  account,
  tokenAddress,
  withSignerIfPossible
) {

  return useContract(
    library,
    account,
    tokenAddress,
    ABI_ERC21_EyesFiMint,
    withSignerIfPossible
  );
}

export function useABI_ERC21_MyNFT(
  library,
  account,
  tokenAddress,
  withSignerIfPossible
) {

  return useContract(
    library,
    account,
    tokenAddress,
    ABI_ERC21_MyNFT,
    withSignerIfPossible
  );
}

export function useABI_ERC21_exchange(
  library,
  account,
  tokenAddress,
  withSignerIfPossible
) {

  return useContract(
    library,
    account,
    tokenAddress,
    ABI_ERC21_exchange,
    withSignerIfPossible
  );
}


export function useABI_ERC20_weth(
  library,
  account,
  tokenAddress,
  withSignerIfPossible
) {

  return useContract(
    library,
    account,
    tokenAddress,
    ABI_ERC20_weth,
    withSignerIfPossible
  );
}

export function useABI_testcon(
  library,
  account,
  tokenAddress,
  withSignerIfPossible
) {

  return useContract(
    library,
    account,
    tokenAddress,
    ABI_testcon,
    withSignerIfPossible
  );
}



//



